<e-dialog
  [open]="target() !== null"
  (openChange)="onOpenChange($event)"
  [title]="text().title"
  [titleData]="target()?.chartName ?? ''"
  size="lg"
  panelClass="relations-dialog-pane"
>
  <ng-template>
    <div class="relations-form">
      @if (error()) {
        <div class="relations-error">{{ error() }}</div>
      }

      @if (loading()) {
        <div class="relations-empty">{{ text().loading }}</div>
      } @else if (visibleRelations().length === 0) {
        <div class="relations-empty">{{ text().none }}</div>
      } @else {
        <div class="relations-list">
          @for (relation of visibleRelations(); track relation.id) {
            <div class="relation-row">
              <i eIcon [icon]="relationIcon(relation.relationType)" class="relation-row-icon"></i>
              <span class="relation-row-type">{{ relationLabel(relation.relationType) }}</span>
              <span class="relation-row-name" [title]="relation.otherChartName">{{ relation.otherChartName }}</span>
              <button
                eBtn
                dense
                size="sm"
                icon="trash"
                iconColor="danger"
                [tooltip]="text().delete"
                (click)="removeRelation(relation)"
              ></button>
            </div>
          }
        </div>
      }

      <div class="relation-add">
        <ng-select
          class="relation-add-chart"
          appendTo=".relations-dialog-pane"
          [items]="chartOptions()"
          bindValue="value"
          bindLabel="label"
          [placeholder]="text().chartPlaceholder"
          [ngModel]="newChartId()"
          (ngModelChange)="newChartId.set($event)"
        ></ng-select>
        <ng-select
          class="relation-add-type"
          appendTo=".relations-dialog-pane"
          [items]="typeOptions()"
          bindValue="value"
          bindLabel="label"
          [clearable]="false"
          [searchable]="false"
          [placeholder]="text().typePlaceholder"
          [ngModel]="newType()"
          (ngModelChange)="newType.set($event)"
        >
          <ng-template ng-label-tmp ng-option-tmp let-item="item">
            <span class="relation-type-option"><i eIcon [icon]="item.icon"></i>{{ item.label }}</span>
          </ng-template>
        </ng-select>
        <button eBtn color="primary-75" icon="plus" [disabled]="!canAdd" (click)="addRelation()">
          {{ text().add }}
        </button>
      </div>
    </div>
  </ng-template>
</e-dialog>
